import React from "react";
import { FaBus, FaCity, FaUser, FaIdBadge } from "react-icons/fa";
import "./Milestones.css";

const milestones = [
  { value: "5.4M", label: "Rides", icon: <FaBus /> },
  { value: "12", label: "Cities", icon: <FaCity /> },
  { value: "1.2M", label: "Users", icon: <FaUser /> },
  { value: "10K", label: "Drivers on Board", icon: <FaIdBadge /> }
];

export default function Milestones() {
  return (
    <div className="milestone-section">
      <h2 className="milestone-title">Milestones Achieved</h2>
      <div className="milestone-container mt-4">
        {milestones.map((item, index) =>
          <div className="milestone-box" key={index}>
            <h2>
              {item.value}
            </h2>
            <div className="milestone-icon-box">
              <div className="milestone-icon">
                {item.icon}
              </div>
              <p>
                {item.label}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
